import * as types from '../actions/actionTypes';

const initialState = {
  openModals: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.OPEN_MODAL:
      return Object.assign({}, state, {
        openModals: state.openModals.concat(action.modalObject)
      });

    case types.CLOSE_MODAL:
      return Object.assign({}, state, {
        openModals: state.openModals.filter((modalObject) => (modalObject.uuid !== action.modalId))
      });
      
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerModals.js